import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "email_template_id": {
      "column": {
        "default": null,
        "name": "email_template_id",
        "null": false,
        "type": null
      },
      "name": "email_template_id",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "parsed_content": {
      "column": null,
      "name": "parsed_content",
      "selected_by_default": false,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "EmailTemplatePreview",
  "collectionKey": "email_template_previews",
  "collectionName": "email_template_previews",
  "i18nKey": "email_template_preview",
  "camelizedLower": "emailTemplatePreview",
  "name": "EmailTemplatePreview",
  "nameDasherized": "email-template-preview",
  "pluralName": "email_template_previews",
  "ransackable_associations": [
    {
      "className": "EmailTemplatePreview::Audit",
      "collectionName": "email_template_preview_audits",
      "foreignKey": "email_template_preview_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "EmailTemplatePreviewAudit",
      "through": null
    },
    {
      "className": "EmailTemplatePreview::Audit",
      "collectionName": "email_template_preview_audits",
      "foreignKey": "email_template_preview_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "EmailTemplatePreviewAudit",
      "through": null
    },
    {
      "className": "EmailTemplatePreview::Translation",
      "collectionName": null,
      "foreignKey": "email_template_preview_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "EmailTemplate",
      "collectionName": "email_templates",
      "foreignKey": "email_template_id",
      "name": "email_template",
      "macro": "belongs_to",
      "resource_name": "EmailTemplate",
      "through": null
    },
    {
      "className": "EmailTemplatePreviewLiquidVariable",
      "collectionName": "email_template_preview_liquid_variables",
      "foreignKey": "email_template_preview_id",
      "name": "liquid_variables",
      "macro": "has_many",
      "resource_name": "EmailTemplatePreviewLiquidVariable",
      "through": null
    },
    {
      "className": "EmailTemplatePreview::Translation",
      "collectionName": null,
      "foreignKey": "email_template_preview_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "email_template_id",
      "column": {
        "default": null,
        "name": "email_template_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "EmailTemplate",
      "collectionName": "email_templates",
      "foreignKey": "email_template_id",
      "name": "email_template",
      "macro": "belongs_to",
      "resource_name": "EmailTemplate",
      "through": null
    },
    {
      "className": "EmailTemplatePreviewLiquidVariable",
      "collectionName": "email_template_preview_liquid_variables",
      "foreignKey": "email_template_preview_id",
      "name": "liquid_variables",
      "macro": "has_many",
      "resource_name": "EmailTemplatePreviewLiquidVariable",
      "through": null
    }
  ],
  "paramKey": "email_template_preview",
  "primaryKey": "id"
}

/** Frontend model for EmailTemplatePreview. */
class EmailTemplatePreview extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  emailTemplateId() {
    return this.readAttributeUnderscore("email_template_id")
  }

  /** @returns {boolean} */
  hasEmailTemplateId() {
    const value = this.emailTemplateId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  parsedContent() {
    return this.readAttributeUnderscore("parsed_content")
  }

  /** @returns {boolean} */
  hasParsedContent() {
    const value = this.parsedContent()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  customParsedContent(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "custom_parsed_content",
        primaryKey: this.primaryKey(),
        collectionName: "email_template_previews",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  sendEmailsToWorkplaceUsers(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "send_emails_to_workplace_users",
        primaryKey: this.primaryKey(),
        collectionName: "email_template_previews",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./email-template.js").default | null} */
  emailTemplate() {
    return this._readBelongsToReflection({reflectionName: "email_template"})
  }

  /** @returns {Promise<import("./email-template.js").default | null>} */
  loadEmailTemplate() {
    if (!("emailTemplateId" in this)) throw new Error("Foreign key method wasn't defined: emailTemplateId")

    const id = this.emailTemplateId()
    const modelClass = modelClassRequire("EmailTemplate")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "email_template", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./email-template-preview-liquid-variable.js").default>} */
  liquidVariables() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("EmailTemplatePreviewLiquidVariable")

    const ransack = {}

    ransack["email_template_preview_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "liquid_variables",
        model: this,
        modelName: "EmailTemplatePreviewLiquidVariable",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./email-template-preview-liquid-variable.js").default>>} */
  loadLiquidVariables() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("EmailTemplatePreviewLiquidVariable")

    const ransack = {}

    ransack["email_template_preview_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "liquid_variables",
        model: this,
        modelClass
      },
      {ransack}
    )
  }
}

export default EmailTemplatePreview
